import i18n from 'i18n';
import { SecurityPolicy } from 'data/securityPolicy/securityPolicy.types';
import { adaptSecurityPolicyData } from 'routes/SecurityPolicy/utils/securityPolicyTemplate.adapter';

/**
 * This function returns a description of the password policy
 * @param passwordPolicy
 */
// eslint-disable-next-line import/prefer-default-export
export const toPasswordPolicyDescription = (passwordPolicy?: SecurityPolicy[]): string => {
  if (!passwordPolicy) return '';
  const adaptedSecurityPolicyData = adaptSecurityPolicyData(passwordPolicy);

  let passwordPolicyDescription = `Password must have a minimum of ${adaptedSecurityPolicyData.minimumPasswordLength} characters`;
  const allowedCharacters = [];
  if (adaptedSecurityPolicyData.requireUppercase === 'true') {
    allowedCharacters.push('uppercase');
  }
  if (adaptedSecurityPolicyData.requireLowercase === 'true') {
    allowedCharacters.push('lowercase');
  }
  if (adaptedSecurityPolicyData.requireNumber === 'true') {
    allowedCharacters.push('number');
  }
  if (adaptedSecurityPolicyData.requireSymbol === 'true') {
    allowedCharacters.push('symbol');
  }
  if (allowedCharacters.length) {
    passwordPolicyDescription += ' with at least';
    allowedCharacters.forEach((allowedCharacter, index) => {
      if (index === allowedCharacters.length - 1) {
        passwordPolicyDescription += ` and 1 ${allowedCharacter}`;
      } else {
        passwordPolicyDescription += ` 1 ${allowedCharacter},`;
      }
    })
  }
  passwordPolicyDescription += '.';

  passwordPolicyDescription += ` Also, password must NOT match one of the last ${adaptedSecurityPolicyData.uniquePasswordHistoryCount} used passwords`;
  const matchNotAllowedPolicies = [];
  if (adaptedSecurityPolicyData.allowPasswordUsernameMatch === 'true') {
    matchNotAllowedPolicies.push('username');
  }
  if (adaptedSecurityPolicyData.allowCurrentPasswordReuse === 'true') {
    matchNotAllowedPolicies.push('current password')
  }
  if (matchNotAllowedPolicies.length) {
    matchNotAllowedPolicies.forEach((matchNotAllowedPolicy, index) => {
      if (index === matchNotAllowedPolicies.length - 1) {
        if (matchNotAllowedPolicies.length > 1) {
          passwordPolicyDescription += ',';
        }
        passwordPolicyDescription += ` or ${matchNotAllowedPolicy}`
      } else {
        passwordPolicyDescription += `, ${matchNotAllowedPolicy}`;
      }
    })
  }

  const notAllowedPatterns = [];
  if (adaptedSecurityPolicyData.allowNumericSequences === 'true') {
    notAllowedPatterns.push('a numeric sequence');
  }
  if (adaptedSecurityPolicyData.maxConsecutiveCharacters === 'true') {
    notAllowedPatterns.push('consecutive characters');
  }
  if (notAllowedPatterns.length) {
    passwordPolicyDescription += ', and must NOT include';
    notAllowedPatterns.forEach((notAllowedPattern, index) => {
      if (index === notAllowedPatterns.length - 1) {
        if (notAllowedPatterns.length === 1) {
          passwordPolicyDescription += ` ${notAllowedPattern}`;
        } else {
          passwordPolicyDescription += ` or ${notAllowedPattern}`;
        }
      } else {
        passwordPolicyDescription += ` ${notAllowedPattern},`
      }
    })
  }
  passwordPolicyDescription += '.';

  return passwordPolicyDescription;
};
